/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';

const AutocompleteCreatableAsync = ({
  name,
  label,
  value,
  error,
  touched,
  required,
  className,
  handleBlur,
  handleFocus,
  loadOptions,
  placeholder,
  handleChange,
  loadingMessage,
  isMulti = false,
  noOptionsMessage,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    let active = true;

    if (inputValue.length < 2) {
      setOptions([]);

      return;
    }

    setLoading(true);

    loadOptions(inputValue).then(results => {
      if (active) {
        setOptions(results);
      }

      setLoading(false);
    });

    return () => active = false;
  }, [inputValue]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`form-outline mb-4 DashBoardInputBx${className ? ` ${className}` : ''}`}>
      <label htmlFor={name} className='form-label'>
        {label}
        {required && <span className='RedStar'>*</span>}
      </label>
      <Autocomplete
        id={name}
        loading={loading}
        options={options}
        multiple={isMulti}
        onBlur={handleBlur}
        onFocus={handleFocus}
        value={value || (isMulti ? [] : null)}
        getOptionLabel={option => option?.label || ''}
        loadingText={loadingMessage?.() || 'Loading...'}
        onChange={(_, selected) => handleChange(selected)}
        onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
        isOptionEqualToValue={(option, val) => option?.value === val?.value}
        noOptionsText={
          inputValue.length < 2
            ? placeholder
            : noOptionsMessage?.({ inputValue }) || 'No options'
        }
        sx={{
          '& .MuiInputBase-root': {
            pl: '16.5px',
            height: '66px',
            fontSize: '17px',
            borderRadius: '6px',
            backgroundColor: '#fff',
            transition: 'border-color 0.2s',
            border: touched && error
              ? '1px dashed #DC3545'
              : '1px dashed #a7a6a6',
            '&:hover': {
              border: touched && error
                ? '1px dashed #DC3545'
                : '1px dashed #a7a6a6',
            },
            '&.Mui-focused': {
              border: touched && error
                ? '1px dashed #DC3545'
                : '1px dashed #a7a6a6',
            },
            '&.Mui-disabled': {
              backgroundColor: '#f5f5f5',
              border: touched && error
                ? '1px dashed #DC3545'
                : '1px dashed #a7a6a6',
            },
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none !important',
          },
          '& .MuiFormHelperText-root': {
            ml: 0,
            mt: 0,
            lineHeight: 1.5,
            fontSize: '16px',
            letterSpacing: 0,
            color: '#DC3545',
          },
          '& input::placeholder': {
            fontSize: '17px',
            letterSpacing: 0,
            opacity: 0.6,
          },
        }}
        renderInput={params => (
          <TextField
            {...params}
            placeholder={placeholder}
            error={Boolean(touched && error)}
            helperText={touched && error ? error : ''}
            slotProps={{
              input: {
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress color='inherit' size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              },
            }}
          />
        )}
      />
    </div>
  );
};

export default AutocompleteCreatableAsync;
